import { Component, OnInit } from '@angular/core';
import { License, SbomService } from '@services/sbom.service';

@Component({
  selector: 'app-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.scss'],
})
export class LicensesComponent implements OnInit {
  serverLicenses: License[] = [];

  serverDependenciesCount = 0;

  clientLicenses: License[] = [];

  clientDependenciesCount = 0;

  constructor(private service: SbomService) {
  }

  ngOnInit(): void {
    this.service.getServerLicenses().subscribe((licenses) => {
      this.serverLicenses = licenses;
      this.serverDependenciesCount = this.serverLicenses.reduce((acc, license) => acc + license.dependencies.length, 0);
    });
    this.service.getClientLicenses().subscribe((licenses) => {
      this.clientLicenses = licenses;
      this.clientDependenciesCount = this.clientLicenses.reduce((acc, license) => acc + license.dependencies.length, 0);
    });
  }
}
